var SENTRY_RELEASE;SENTRY_RELEASE={name: "Aphasie", version: "1.10.34"};